import React, { useState } from "react";

import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Footer from "../../components/Footer";
import Accordion from "react-bootstrap/Accordion";

import NyliaButton from "../nyliaButton/NyliaButton.js";

import petitSchedule from "../../assets/summerIntensivesPage/2026PetitBalletSchedule.pdf";
import juniorSchedule from "../../assets/summerIntensivesPage/2026JuniorBalletSchedule.pdf";
import preprofessionalSchedule from "../../assets/summerIntensivesPage/2026Pre-ProfessionalBalletSchedule.pdf";
import beginnerSchedule from "../../assets/summerIntensivesPage/2026BeginnerBalletSchedule.pdf";

import "./SI.css";
import "../NyliaStyles/Nylia.css";
import * as siConstClass from "./SIConstants.js";

function SI() {
  const goToSection = (sectionId) => {
    document.getElementById(sectionId).scrollIntoView(false);
  };

  function dropDownInformation({
    levelDescription,
    wk1Dates,
    wk1Times,
    wk2Dates,
    wk2Times,
    curriculum,
    attire,
    tuition,
    schedule,
  }) {
    return (
      <p>
        <i>{levelDescription}</i>
        <br />
        <br />
        <div id="summerIntensiveAccordionButton">
          <NyliaButton link={schedule} label={"View Schedule"}></NyliaButton>
        </div>
        <br />
        <hr></hr>
        <b>
          <i>DATE & TIME</i>
        </b>
        <hr></hr>
        <ul>
          Week 1
          <ul>
            <li>{wk1Dates}</li>
            <li>{wk1Times}</li>
          </ul>
          <br></br>
          Week 2
          <ul>
            <li>{wk2Dates}</li>
            <li>{wk2Times}</li>
          </ul>{" "}
          <br></br>
          {siConstClass.concertoTitle}
          <ul>
            <li>{siConstClass.concertoDate}</li>
            <li>{siConstClass.concertoTime}</li>
          </ul>
        </ul>
        <hr></hr>
        <i>
          <b>CURRICULUM</b>
        </i>
        <hr></hr>
        <ul>
          <ul>{renderCurriculum(curriculum)}</ul>
        </ul>
        <hr></hr>
        <i>
          <b>ATTIRE</b>
        </i>
        <hr></hr>
        <ul>{renderAttire(attire)}</ul>
        <hr></hr>
        <i>
          <b>TUITION</b>
        </i>
        <hr></hr> <ul>{tuition}</ul>
      </p>
    );
  }

  function renderAttire(attire) {
    return attire.map((attireSection, index) => (
      <div>
        {attireSection.title}
        <ul>
          {attireSection.bullets.map((item, index) => (
            <li>{item}</li>
          ))}
        </ul>
        <br></br>
      </div>
    ));
  }

  const renderCurriculum = (curriculum) => {
    return curriculum.map((item, index) => <li>{item}</li>);
  };

  function intensiveBox({
    siTitle,
    siDates,
    siCaption,
    w1Dates,
    w2Dates,

    l1Title,
    l1Caption,
    l1Times,
    l1Curriculum,
    l1Attire,
    l1Tuition,
    l1Schedule,

    l2Title,
    l2Caption,
    l2Times,
    l2Curriculum,
    l2Attire,
    l2Tuition,
    l2Schedule,

    l3Title,
    l3Caption,
    l3Times,
    l3Curriculum,
    l3Attire,
    l3Tuition,
    l3Schedule,

    l4Title,
    l4Caption,
    l4Times,
    l4Curriculum,
    l4Attire,
    l4Tuition,
    l4Schedule,
  }) {
    return (
      <div className="main-box">
        <br></br>
        <h1 id="highlightTitle">{siTitle}</h1>
        <h3>{siDates}</h3>
        <br></br>
        <p>{siCaption}</p> <br></br>
        <div className="shadow-box">
          <Accordion flush>
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <h2 id="highlightTitle">
                  <b>{l1Title}</b>
                </h2>
              </Accordion.Header>
              <Accordion.Body>
                {dropDownInformation({
                  levelDescription: l1Caption,
                  wk1Dates: w1Dates,
                  wk1Times: l1Times,
                  wk2Dates: w2Dates,
                  wk2Times: l1Times,
                  curriculum: l1Curriculum,
                  attire: l1Attire,
                  tuition: l1Tuition,
                  schedule: l1Schedule,
                })}
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                <b id="highlightTitle">{l2Title}</b>
              </Accordion.Header>
              <Accordion.Body>
                {dropDownInformation({
                  levelDescription: l2Caption,
                  wk1Dates: w1Dates,
                  wk1Times: l2Times,
                  wk2Dates: w2Dates,
                  curriculum: l2Curriculum,
                  wk2Times: l2Times,
                  attire: l2Attire,
                  tuition: l2Tuition,
                  schedule: l2Schedule,
                })}
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>
                <b id="highlightTitle">{l3Title}</b>
              </Accordion.Header>
              <Accordion.Body>
                {dropDownInformation({
                  levelDescription: l3Caption,
                  wk1Dates: w1Dates,
                  wk1Times: l3Times,
                  wk2Dates: w2Dates,
                  curriculum: l3Curriculum,
                  wk2Times: l3Times,
                  attire: l3Attire,
                  tuition: l3Tuition,
                  schedule: l3Schedule,
                })}
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              <Accordion.Header>
                <b id="highlightTitle">{l4Title}</b>
              </Accordion.Header>
              <Accordion.Body>
                {dropDownInformation({
                  levelDescription: l4Caption,
                  wk1Dates: w1Dates,
                  wk1Times: l4Times,
                  wk2Dates: w2Dates,
                  curriculum: l4Curriculum,
                  wk2Times: l4Times,
                  attire: l4Attire,
                  tuition: l4Tuition,
                  schedule: l4Schedule,
                })}
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4">
              <Accordion.Header>
                <b id="highlightTitle">START EXPLORING</b>
              </Accordion.Header>
              <Accordion.Body>
                <div className="main-box">{siNavBar()}</div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
        <NyliaButton
          link={siConstClass.applicationLink}
          label={"Register today!"}
        ></NyliaButton>
      </div>
    );
  }

  function siNavBar() {
    return (
      <div className="siSectionsButtons">
        {siConstClass.siSections.map((item, index) => (
          <Button onClick={() => goToSection(item.link)} variant="outline-info">
            {item.title}
          </Button>
        ))}
      </div>
    );
  }

  function renderQandAs() {
    return siConstClass.qAndA.map((item, index) => (
      <Accordion.Item eventKey={index}>
        <Accordion.Header>
          <b id="highlightTitle">{item.q}</b>
        </Accordion.Header>
        <Accordion.Body>
          {item.a}
          {item.link && (
            <div className="qAndAsButton">
              <br></br>
              <NyliaButton
                link={item.link}
                label={item.linkLabel}
              ></NyliaButton>
              <br></br>
            </div>
          )}
        </Accordion.Body>
      </Accordion.Item>
    ));
  }

  return (
    <div class="main-container si-container">
      <div className="main-img-bkg" id="enroll-section">
        <div className="main-title">
          <h1>SUMMER INTENSIVES</h1>
        </div>
        <div className="main-box">
          <p>
            <b>
              <i>
                Join Nylia Ballet Academy for Two Weeks of Focused Summer
                Intensive Training
              </i>
            </b>
            <br />
            <br />
            Our Summer Intensive offers comprehensive ballet training for
            dancers of all ages and levels, from young beginners to adult
            students. Explore your potential, grow your technique, and shine in
            our final performance, <i>Summer Concerto</i>, with the Nylia Ballet
            Company. Apply today to reserve your spot!
          </p>
          <NyliaButton
            link={siConstClass.applicationLink}
            label={"APPLY TODAY"}
          ></NyliaButton>
        </div>
      </div>
      <div className="main-bkg" id="siYouthTeenAdultSection">
        {intensiveBox({
          siTitle: siConstClass.siTitle,
          siDates: siConstClass.intensiveDates,
          siCaption: siConstClass.youthCaption,
          w1Dates: siConstClass.week1Dates,
          w2Dates: siConstClass.week2Dates,

          l1Title: siConstClass.levelOptions.petiteBallet.levelTitle,
          l1Caption: siConstClass.levelOptions.petiteBallet.levelDesc,
          l1Times: siConstClass.levelOptions.petiteBallet.levelTimes,
          l1Curriculum: siConstClass.levelOptions.petiteBallet.curriculum,
          l1Attire: siConstClass.levelOptions.petiteBallet.attire,
          l1Tuition: siConstClass.levelOptions.petiteBallet.tuition,
          l1Schedule: petitSchedule,

          l2Title: siConstClass.levelOptions.juniorBallet.levelTitle,
          l2Caption: siConstClass.levelOptions.juniorBallet.levelDesc,
          l2Times: siConstClass.levelOptions.juniorBallet.levelTimes,
          l2Curriculum: siConstClass.levelOptions.juniorBallet.curriculum,
          l2Attire: siConstClass.levelOptions.juniorBallet.attire,
          l2Tuition: siConstClass.levelOptions.juniorBallet.tuition,
          l2Schedule: juniorSchedule,

          l3Title: siConstClass.levelOptions.preProfessional.levelTitle,
          l3Caption: siConstClass.levelOptions.preProfessional.levelDesc,
          l3Times: siConstClass.levelOptions.preProfessional.levelTimes,
          l3Curriculum: siConstClass.levelOptions.preProfessional.curriculum,
          l3Attire: siConstClass.levelOptions.preProfessional.attire,
          l3Tuition: siConstClass.levelOptions.preProfessional.tuition,
          l3Schedule: preprofessionalSchedule,

          l4Title: siConstClass.levelOptions.beginnerBallet.levelTitle,
          l4Caption: siConstClass.levelOptions.beginnerBallet.levelDesc,
          l4Times: siConstClass.levelOptions.beginnerBallet.levelTimes,
          l4Curriculum: siConstClass.levelOptions.beginnerBallet.curriculum,
          l4Attire: siConstClass.levelOptions.beginnerBallet.attire,
          l4Tuition: siConstClass.levelOptions.beginnerBallet.tuition,
          l4Schedule: beginnerSchedule,
        })}
      </div>
      <div className="main-img-bkg" id="siTuitionSection">
        <div className="main-box">
          <h1 id="highlightTitle">TUITION & FEES</h1>{" "}
          <h3>All payments are due by Wednesday, July 8</h3>
          <br />
          <p>
            Tuition covers all classes and training throughout the Summer
            Intensive. Each dancer will also participate in the final
            performance, Summer Concerto, presented by the Nylia Ballet Company.
            <br></br>
            <br></br>
            <br></br> <b>Tuition</b>
            <ul>
              <li>Petite Ballet (Ages 3–8): $350</li>
              <li>Junior Ballet (Ages 9–12): $350 </li>
              <li>Pre-Professional (Teen & Adult): $350</li>
              <li>Beginner Ballet (Teen & Adult): $350</li>
            </ul>
            <br></br> <b>What Tuition Includes</b>
            <ul>
              <li>Daily ballet training and classes</li>
              <li>Instruction from experienced faculty</li>
              <li>Rehearsals and preparation for the final performance</li>
              <li>Participation in Summer Concerto on Saturday, July 25</li>
            </ul>
            <br></br> <b>Payment</b>
            <ul>
              <li>
                Full tuition payment is required to secure a dancer’s place in
                the program.
              </li>
              <li>
                Payment instructions will be provided after submitting the
                application form.
              </li>
            </ul>
            <br></br> <b>Scholarships</b>
            <br></br>
            <ul>
              A limited number of merit-based scholarships are available and are
              awarded case-by-case at the time of audition.
            </ul>
            <br></br> <b>Important Policies</b>
            <ul>
              <li>Tuition payments are non-refundable.</li>
              <li>
                Partial attendance does not reduce tuition, and the full program
                fee is required even if a dancer misses a day.
              </li>
              <li>
                Placement is based on the level selected during registration and
                may be adjusted if needed.
              </li>
            </ul>
          </p>
        </div>
      </div>
      <div className="main-bkg" id="qaSection">
        <div className="main-box">
          <br></br>
          <h1 id="highlightTitle">Q&A's</h1>
          <br></br>
          <div className="shadow-box">
            <Accordion flush>{renderQandAs()}</Accordion>
          </div>
        </div>
      </div>
      <div className="main-img-bkg" id="uniform-section">
        <div className="main-box">
          <h1 id="highlightTitle test">CLASSICAL BALLET TRAINING</h1>
          <br />
          <p>
            Ballet intensives are immersive training programs that provide
            dedicated dancers with an intensive and focused experience to refine
            their ballet technique, artistry, and performance skills. In
            addition to technical training, ballet intensives often offer
            opportunities for dancers to work with our renowned instructors and
            choreographers from the ballet world. These interactions provide
            invaluable mentorship, feedback, and insights into the professional
            dance industry. Participation in ballet intensives can offer
            numerous benefits for dancers, including accelerated skill
            development, increased strength and flexibility, expanded artistic
            expression, and networking opportunities. Many dancers view
            intensives as a crucial step in their training journey, helping them
            to further their passion for ballet and pursue their aspirations of
            becoming professional dancers.
          </p>
          {siNavBar()}
        </div>
      </div>
      <Footer></Footer>
    </div>
  );
}

export default SI;
